module.exports = __webpack_public_path__ + "static/westloop-c7683ec8b3dc45463ca96deb7600e27c.png";